const resources = {
    showMore: 'Show More',
    viewing: 'Viewing',
    results: 'results'
};

module.exports = function getResource(label) {
    return resources[label];
};
